import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRouter from './utils/PrivateRouter'
import Home from '@pages/Home'
import MediaVideo from '@pages/MediaVideo'
import MediaFile from '@pages/MediaFile'

const HomeRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<PrivateRouter />}>
        <Route path="/" element={<Home />} />
        <Route path="/media/video" element={<MediaVideo />} />
        <Route path="/media/file" element={<MediaFile />} />
      </Route>
    </Routes>
  )
}

export default HomeRouter
